import { render, staticRenderFns } from "./lainavertailija.vue?vue&type=template&id=2879f31a&"
import script from "./lainavertailija.vue?vue&type=script&lang=js&"
export * from "./lainavertailija.vue?vue&type=script&lang=js&"
import style0 from "./lainavertailija.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports